const MONTH_DIFF = 1;
const LEADING_ZERO_BREAKPOINT = 10;

const addLeadingZero = (value: number): string => (value < LEADING_ZERO_BREAKPOINT ? `0${value}` : value.toString());

const toDateStringUtil = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + MONTH_DIFF;
  const day = date.getDate();

  return `${year}-${addLeadingZero(month)}-${addLeadingZero(day)}`;
};

export default toDateStringUtil;
